import { render, staticRenderFns } from "./Contractors.vue?vue&type=template&id=f4495dc0&scoped=true&"
import script from "./Contractors.vue?vue&type=script&lang=ts&"
export * from "./Contractors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4495dc0",
  null
  
)

export default component.exports